import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router';
import Steps from "../../../components/steps/steps";
import TransferInstruction from "./components/transfer-instruction/transfer-instruction";
import TransferAuthorization from "./components/transfer-authorization/transfer-authorization";
import TransferConfirmation from "./components/transfer-confirmation/transfer-confirmation";
import TransferSubmitted from "./components/transfer-submitted/transfer-submitted";
import {Row, Col} from 'react-bootstrap';
import Loading from "../../../components/loading/loading";
import Transfer from "../../../models/transfer";
import SecondaryMarketService from "../../../services/secondary-market-service";

const TransferForm = () => {
  //Transfer Transfer Form Steps
  const keys = [
    { id: 'transferInstruction', name: 'TRANSFER INSTRUCTION' },
    { id: 'transferAuthorization', name: 'AUTHORIZATION'  },
    { id: 'transferConfirmation', name: 'CONFIRMATION' },
    { id: 'transferSubmitted', name: 'SUBMITTED'}
  ]
  //Retrieve security id from params
  const { transferId }  = useParams();
  //Main Transfer Form state
  const [ loading, setLoading ] = useState(true);
  const [ transferFormState, setTransferFormState ] = useState(new Transfer());
  const [ initialTransferInfoState, setInitialTransferInfoState ] = useState({});

  const secondaryMarketService = new SecondaryMarketService();

  //Proceed to next step or back 1 step
  const [ activeTabIndex, setActiveTabIndex ] = useState(0);

  useEffect(() => {
    const getInitialTransferInformation = async () => {
      try {
        const initialTransferInfo = await secondaryMarketService.getTransfer(transferId);
        setInitialTransferInfoState(initialTransferInfo);
      } catch(error){
        //show appropriate page
      } finally {
        setLoading(false);
      }
    }
    getInitialTransferInformation();
  }, []);
  const next = () => {
    if( activeTabIndex <= keys.length ){
      setActiveTabIndex(activeTabIndex + 1);
      window.scrollTo({top: 0});
    }
  }
  const back = () => {
    if( back && activeTabIndex > 0 ){
      setActiveTabIndex( activeTabIndex - 1 );
      window.scrollTo({top: 0});
    }
  }


  //Render transfer transfer form sections
  const renderSection = () => {
    switch( keys[activeTabIndex].id ) {
      case 'transferInstruction':
        return <TransferInstruction context={{initialTransferInfoState,  transferFormState, setTransferFormState}} controls={{next}}/>
      case 'transferAuthorization':
        return <TransferAuthorization context={{transferFormState, setTransferFormState}} controls={{next, back}}/>
      case 'transferConfirmation':
        return <TransferConfirmation context={{initialTransferInfoState, transferFormState, setTransferFormState}} controls={{next, back}}/>
      case 'transferSubmitted':
        return <TransferSubmitted/>
      default:
    }
  }
  return loading ? <Loading /> : (
    <div>
      <Row>
        <Col lg={{offset: 2, span: 8}}>
          <Steps activeKeyIndex={activeTabIndex} keys={keys}/>
          {renderSection()}
        </Col>
      </Row>
    </div>
  )

}

export default TransferForm;
